import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import UnblockModal from "./modal/UnblockModal";
import { Dropdown } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function Blocked() {
  const [blockList, setBlockList] = useState([]);
  const { user,dispatch } = useAuthContext();
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [unblockModal, setUnblockModal] = useState(false);
  const [isLoading,setIsLoading] = useState(true)
const navi = useAuthContext();
  const cancelModal = () => {
    setUnblockModal(false);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const blockedResponse = await axios.get(
        `${ApiConnectionString}/api/BlockedUsers`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (blockedResponse.status === 200) {
        setBlockList(blockedResponse.data);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching blocked users:", error);
    } finally {
      setIsLoading(false);
    }
  };
  

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);


  if(isLoading){
    return(
      <div><LoadingSpinner /></div>
    )
  }else{

  return (
    <div>
         <div className='lightBlueBanner mt-2'>
<p className=' fw-bold p-2'>Blocking</p>
      </div>
      {blockList.map((item) => (
        <div
          className="bg-white d-flex profileBox rounded shadow mt-3"
          key={item.id}
        >
          <div>
            <img
              src={
                item.image
                  ? `${ApiConnectionString}/api/profileImage/${item.id}`
                  : ProfilePlaceHolder
              }
              alt="Profile Image"
              width={200}
              className=" m-3 circle-crop"
            />
          </div>

          <div className="mx-5 mt-5">
            <p className="red-text">Username</p>
            <p className="fw-bold mt-2">{item.username}</p>
          </div>

          <div className="ms-auto align-self-start">
            <Dropdown>
              <Dropdown.Toggle
                as="span"
                id="dropdown-custom-components"
                className="dropdown-toggle-custom"
              >
                <ThreeDotsVertical
                  onClick={() => setSelectedProfile(item)}
                  style={{ cursor: "pointer" }}
                  size={25}
                  className="m-2"
                />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    setUnblockModal(true);
                  }}
                >
                  Unblock
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      ))}

      {blockList.length == 0 &&
        <p className="text-muted">No blocked users</p>
      }
      {unblockModal && (
        <UnblockModal
          cancelModal={cancelModal}
          profile={selectedProfile}
          fetchData={fetchData}
        />
      )}
    </div>
  );
}
}